import { useEffect, useState } from "react";
import { getHistoryEntryTypes } from "../../api/historyService";

export const useHistoryEntryTypes = (trigger, emptyCallback) => {
  const [historyEntryTypes, setHistoryEntryTypes] = useState({});
  const [loading, setLoading] = useState(true);

    useEffect(() => {
        getHistoryEntryTypes()
            .then((types) => {
                setHistoryEntryTypes(types.data);
                if (emptyCallback && types.data.length === 0) {
                    emptyCallback(true);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch history entry types:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [trigger]);

  return { historyEntryTypes, loading, setHistoryEntryTypes };
};
